import { send } from '../../../../src/network';

/** Represents the Dietary Restriction returned from `/api/v2/dietary_restrictions/` - no customer preference info included  */
export interface DietaryRestrictionConfig {
  field_name: string;
  id: number;
  is_active: boolean;
  is_core: boolean;
  name: string;
  remark: string;
  selected: boolean | null;
  slug: string;
  sort_order: number;
  thumbnail: string;
  thumbnail_url: string;
}

export interface DietaryRestrictionsResponse {
  results: DietaryRestrictionConfig[];
}

const buildParams = () => {
  const params = new URLSearchParams();
  params.append('limit', '1000'); // this is far more than we should ever get, but we want to make sure we get all of them
  return params;
};

export async function getDietaryRestrictions() {
  return await send<DietaryRestrictionsResponse>({
    path: `/api/v2/dietary_restrictions/`,
    method: 'GET',
    query: buildParams(),
  });
}
